import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Option } from '@tcc-mono/vandijk/shared/data-access/models';
import { OptionService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';

@Injectable({
  providedIn: 'root'
})
export class OptionRepository extends CoreRepository<Option> {

  public constructor(
    protected readonly _optionService: OptionService
  ) {
    super(
      { name: 'options' },
      _optionService
    )
  }
}
